import { Image } from "react-native";

export const resolveAssetSource = (source: { uri: string }) => {
    return new Promise<{ uri: string; width: number; height: number }>((resolve, reject) => {
        Image.getSize(
            source.uri,
            (width, height) => {
                resolve({ uri: source.uri, width, height });
            },
            (error: Error) => {
                reject(error);
            },
        );
    });
};
